import React from 'react'
import PropTypes from 'prop-types'

import { Link as RouterLink } from 'react-router-dom'

import { Link as MaterialLink } from '@material-ui/core'

const Link = ({
  noPropagate = false,
  onClick = () => {},
  children,
  ...rest
}) => {
  const handleClick = event => {
    if (noPropagate) {
      event.stopPropagation()
    }

    onClick(event)
  }

  return (
    <MaterialLink component={RouterLink} onClick={handleClick} {...rest}>
      {children}
    </MaterialLink>
  )
}

export default Link

Link.propTypes = {
  noPropagate: PropTypes.bool,
  onClick: PropTypes.func,
}
